<div class="dro-reading-popup">
  <header class="popup-header">
    <div class="header-title">
      <span class="reading-id">{{ reading?.readingId ?? data.readingId }}</span>
      @if (reading) {
        <span class="serial"> - {{ reading.serialNumber }}</span>
      }
    </div>
    <i class="fas fa-times pointer" (click)="onClose()"></i>
  </header>

  <div class="popup-body">
    @if (showLoader) {
      <lib-loader></lib-loader>
    } @else if (reading) {
      <div class="summary">
        <div>
          <div class="label">Reading Date</div>
          <div class="value">{{ formatDate(reading.readingDate) }}</div>
        </div>
        <div>
          <div class="label">Recorded By</div>
          <div class="value">
            {{ reading.recordedBy }}
            @if (reading.recordedByRoles.length) {
              <span class="role-chip">{{ reading.recordedByRoles.join(' / ') }}</span>
            }
          </div>
        </div>
        <div>
          <div class="label">Source</div>
          <div class="value">{{ reading.serviceOrderId ?? 'Standalone' }}</div>
        </div>
      </div>

      <div class="values">
        @for (item of reading.values; track item.fieldCode) {
          <div class="value-row">
            <span class="field-label">{{ item.label }}@if (item.unit) { ({{ item.unit }})}</span>
            <span class="field-value" [class.text-value]="item.dataType === 'Text'">{{ formatValue(item.value, item.decimalPlaces) }}</span>
            <span class="field-difference" [class.negative]="item.difference !== null && item.difference < 0">
              {{ formatDifference(item.difference, item.decimalPlaces) }}
            </span>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">This reading could not be loaded. It may have been deleted.</div>
    }
  </div>

  <footer class="popup-footer">
    <button type="button" class="btn btn-sm btn-danger" (click)="onClose()">Close</button>
    @if (canDelete && reading) {
      <button type="button" class="btn btn-sm btn-delete" [disabled]="deleting" (click)="onDelete()">Delete reading</button>
    }
  </footer>
</div>
